import React from 'react'
import style from "css/todayReservation.module.css";
import ParticipantDropdown from './participantDropdown';

function MeetingRoomCard({ schedule, type }) {

    const getTimeforHourlySchedule = (startDateTime, endDateTime) => {
        const options = { hour: '2-digit', minute: '2-digit', hour12: false };

        const startTime = new Date(startDateTime).toLocaleTimeString([], options);
        const endTime = new Date(endDateTime).toLocaleTimeString([], options);

        return `${startTime}-${endTime}`;
    }

    const getEndpoint = (endpointStr) => {
        return endpointStr !== undefined && endpointStr !== "" ? endpointStr.split(";")[0] : "-";
    }

    return (
        <div key={schedule.id} className={style.meetingroom_data_wrapper}>
            <div className={style.meetingroom_data_container}>
                {type !== "Today" && <div className={style.col_0}>2025-03-27</div>}
                <div className={style.col_1}>{getTimeforHourlySchedule(schedule.START_DATETIME, schedule.END_DATETIME)}</div>
                <div className={style.col_2}>{getEndpoint(schedule.ENDPOINTLIST)}</div>
                <div className={style.col_3} style={{ width: type === "Today" ? "46%" : "28%" }}>{schedule.TITLE}</div>
                <div className={style.col_4}>
                    <ParticipantDropdown
                        participants={schedule.PARTICIPANTS !== null && schedule.PARTICIPANTS !== undefined ? schedule.PARTICIPANTS : []}
                    />
                </div>
            </div>
        </div>
    )
}

export default MeetingRoomCard
